 import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import ScheduleView from "../../widgets/ScheduleView";
import InsertMeetingWidget from "../../widgets/InsertMeetingWidget";
import EditMeetingWidget from "../../widgets/EditMeetingWidget";
import getCorso from "../../services/getCorso";
import getLezioni from '../../services/getLezioni';
import getChiusura from '../../services/getChiusura';
import getInsegnanti from '../../services/getInsegnanti';
import moment from 'moment';
import Utils from '../../utils/utils';
import { EditorState } from 'draft-js';
import { NineCellLoading } from 'react-loadingg';
import 'moment/locale/it';
import 'moment/locale/en-gb';
import translateString from "../../utils/Locales";
import getClient from "../../services/getClient";
import getAccessToken from "../../services/getGoogleToken";
import { gapi } from 'gapi-script';

let t = translateString;
//const gapi = window.gapi;

export default class Schedule extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.dataSourceCords = 0;
    this.todayRef = React.createRef();

    this.linkClicked = false;

    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    this.titlePage = '';

    this.timePrecision = 15;

    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];
    this.subjectName = '';
    this.eventDays = [];
    this.meetings = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      editorState: EditorState.createEmpty()
    }

    this.grid = 2;

    this.state = {
      newEventParam: {
        visible: false
      },
      editEventParam: {
        visible: false,
        meeting: undefined
      },
      editBreakParam: {
        visible: false,
        break: undefined
      }, 
      needToScroll: true,
      googleEvents: [],
    };

  }

  async start(tok) {
    
    gapi.client.init({
      apiKey: 'AIzaSyCZhvxNOXSc5Q-Av_d9f6SEDqpubRBH8-4',
      clientId: "656471515583-qiupck5f2a3cuod1j9kdvl08gfp4jfqr.apps.googleusercontent.com",
      scope: 'https://www.googleapis.com/auth/calendar',
      plugin_name: 'AppiusAcademy'
    });

    gapi.client.setToken({ access_token: tok });

    let request = gapi.client.calendar.events.list({
      'calendarId': 'primary',
      "singleEvents" : true,
      "orderBy" : "startTime",
      "timeMin":  moment(this.corso.dateStart, 'yyyy-MM-DD').toDate().toISOString(),
      "timeMax":  moment(this.corso.dateEnd, 'yyyy-MM-DD').toDate().toISOString()
    });

    let that = this;

    request.execute(function (response) {

      var eventi = response.result.items;
      eventi.forEach((e) => {
          let startDate = moment(e.start.dateTime, 'yyyy-MM-DDTHH:mm:ss.SSSz');
          let endDate = moment(e.end.dateTime, 'yyyy-MM-DDTHH:mm:ss.SSSz');
          var durata = moment.duration(endDate.diff(startDate)).asMinutes();
          e.data = startDate.format('yyyy-MM-DD HH:mm:ss');
          e.durata = durata;
      });
      that.setState({ googleEvents: eventi });
    });

  }

  async reload() {
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const scheduleType = cookies.get('scheduleType', { path: '/' });
    const currentCourse = cookies.get('currentCourse', { path: '/' });
    this.brokerFlag = cookies.get('brokerFlag', { path: '/' });

    let cliente = await getClient('', '', cookies.get('db', { path: '/' }));
    this.corso = await getCorso(username, token, currentCourse);
    this.lezioni = await getLezioni(username, token);
    this.chiusura = await getChiusura(username, token);
    this.insegnanti = await getInsegnanti(username, token);

    let tok = cliente.g_refresh_token;
    if (tok) {
      var access_token = await getAccessToken(username, token, tok);
      if (access_token && access_token.result === 'ok') {
        access_token = access_token.access_token;
      } else {
        access_token = undefined;
      }
      if (access_token) {
        gapi.client.load('calendar', 'V3', () => this.start(access_token));
      }
    }

    this.lezioni = this.lezioni.filter(l => { 
      var altriCorsi = l.altri_corsi.split(';');
      return l.id_corso == currentCourse || altriCorsi.indexOf(currentCourse) != -1
    });

    this.scheduleType = scheduleType;
    this.scheduleSubject = currentCourse;
    this.savedEnabled = false;
    this.subjectName = this.corso.nome;

    var startDate = this.corso.dateStart;
    var endDate = this.corso.dateEnd;

    startDate = moment(startDate, "yyyy-MM-DD");
    endDate = moment(endDate, "yyyy-MM-DD");

    // Elimina i giorni di chiusura e i week end
    this.courseDays = [];
    var tempDate = startDate;
    while (tempDate <= endDate){
      var chiusura = false;
      var weekEnd = false;
      this.chiusura.forEach(element => {
        if (element.day == moment(tempDate).format('DD-MM-yyyy'))
          chiusura = true;
      });

      if (moment(tempDate).day() == 0 || moment(tempDate).day() == 6)
        weekEnd = true;

      if (chiusura == false)
        this.courseDays.push(moment(tempDate));

      tempDate = tempDate.add(1, 'd');
    }
    
    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    this.setState({ editEventParam: { visible: false, meeting: undefined, isLoading: false } });

    if (cookies.get('scrollToDate', { path: '/' }) !== '' && cookies.get('scrollToDate', { path: '/' }) !== undefined) {
      cookies.set('scrollToDate', '', { path: '/' });
    }

    this.setState({ });
    /* if (this.state.needToScroll) {
      try {
        this.todayRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch(e) {
        console.log(e);
      }
    } */

  }

  componentDidUpdate() {
    if (this.state.needToScroll && !this.state.isLoading) {
      try {
        this.todayRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.setState({ needToScroll: false });
      } catch(e) {
        console.log(e);
      }
    }
  }

  onContentStateChange = contentState => {

    this.savedEnabled = true;
    this.setState({ contentState});
  }

  async componentDidMount(){

    this.reload();
  }

  hideEditWindow () {
    this.linkClicked = true;
    this.setState({editEventParam: {visible: false }});
    this.setState({editBreakParam: {visible: false }});
  }

  render () {

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (!this.corso) return <div/>;

    const cookies = new Cookies();
    const currentCourse = cookies.get('currentCourse', { path: '/' });

    this.linkClicked = false;

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('calendario') + " " + this.corso.name} />
        { 
          this.courseDays.map((v) => {
            moment.locale(t('language_string'));
            
            var todayDate = '';
            var currDate = moment();
            let dateToScroll = cookies.get('scrollToDate', { path: '/' });
            if (dateToScroll != '' && dateToScroll != undefined) {
              todayDate = moment(dateToScroll).subtract(2, 'days');
            } else {
              todayDate = moment().subtract(2, 'days');
            }

            let date_str = Utils.capitalizeFirstLetter(moment(v).format('dddd LL')) ;
            let date = moment(v).format('yyyy-MM-DD');
            var isToday = false;
            var isCurrent = false;

            if (moment(v).format('dddd LL') == moment(todayDate).format('dddd LL')) {
              isToday = true;
            }

            if (moment(v).format('dddd LL') == moment(currDate).format('dddd LL')) {
              isCurrent = true;
            }

            var eventi = [];
            this.state.googleEvents.forEach((e) => {
                if (moment(e.data, 'yyyy-MM-DD HH:mm:ss').format('yyyy-MM-DD') === date) {
                  eventi.push(e);
                }
            });

            return (
            <div id={"#"+date} key={Math.random()} style={{minHeight: '155px', marginTop: 20}} ref={ isToday ? this.todayRef : null }>
              <div key={Math.random()} className={"dayString" + (isCurrent ? " today" : "")}>{date_str}</div>
              <ScheduleView 
                key={Math.random()}
                breaks={this.breaks} 
                timePrecision={this.timePrecision}
                date={date} 
                parent={this}
                lezioni={this.lezioni}
                eventi={eventi}
                type={this.scheduleType}
                subject={currentCourse}
                insegnanti={this.insegnanti}
                onMouseClick={(date, time) => {
                  
                  if (this.linkClicked == true) return;
                  
                  for (var i = 0; i < this.lezioni.length; i++){

                    let m = this.lezioni[i];
                    let meetingDate = m.data.split(' ')[0];
                    let meetingTime = m.data.split(' ')[1];
                    let hour = meetingTime.split(':')[0];
                    let minutes = meetingTime.split(':')[1];

                    console.log(m.durata);
                    var meetingStart = moment(meetingDate + " " + hour+":"+minutes, "yyyy-MM-DD HH:mm");
                    var meetingEnd = moment(meetingStart).add(parseInt(m.durata), 'minutes');

                    let currentClickTime = moment(date + " " + time, "yyyy-MM-DD HH:mm");
                    if (currentClickTime >= meetingStart && meetingEnd > currentClickTime) {

                      this.setState({
                        editEventParam: {
                          visible: true,
                          meeting: m,
                        }, 
                        selectedDate: date
                      });

                      return;
                    }
                  }

                  this.setState({
                    newEventParam: {
                      visible: true,
                      date: date,
                      time: time,
                    },
                    selectedDate: date,
                    anchor: date
                  });
                }}
              />
            </div> )
          })
        }
        
        
        { this.state.editEventParam.meeting && <EditMeetingWidget 
          key={Math.random()}
          visible={this.state.editEventParam.visible ? true : false}
          meeting={this.state.editEventParam.meeting} 
          lezioni={this.lezioni}
          date={this.state.selectedDate}
          time={this.state.newEventParam.time}
          timePrecision={this.timePrecision}
          scheduleType={this.scheduleType}
          subjectName={this.subjectName}
          subjectId={currentCourse}
          investors={this.investors}
          companies={this.companies}
          onDone={() => {
            this.reload();
            this.setState({editEventParam: {visible: false }, needToScroll: false });
          } }
        />
        }

        <InsertMeetingWidget 
          key={Math.random()}
          visible={this.state.newEventParam.visible ? true : false}
          date={this.state.newEventParam.date}
          time={this.state.newEventParam.time}
          meetings={this.meetings} 
          aule={this.aule} 
          scheduleType={this.scheduleType}
          timePrecision={this.timePrecision}
          subjectName={this.subjectName}
          subjectId={currentCourse}
          onDone={() => {
            this.reload();
            this.setState({newEventParam: {visible: false }, needToScroll: false });
          } }
        />
        </LoadingOverlay>
      </>
    );
  }

}

